import React, { useState } from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import { useProjectState } from "../../../context/stateContext";
import WaiterInfoModal from "./WaiterInfoModal";

export const getTotalSum = (waitersTurnOver, method) => {
  let dataProductsTotalSum = 0;
  if (waitersTurnOver.length === 0) return 0.0;
  else {
    waitersTurnOver.forEach((element) => {
      dataProductsTotalSum += element[method];
    });
    return dataProductsTotalSum;
  }
};

const WaiterInfoTable = () => {
  const [selectedRecord, setSelectedRecord] = useState({});

  const { setShowWaiterSalesDetails, showPaymentMethods } = useProjectState();
  const { waitersTurnOver, loading } = useSelector(
    (state) => state.waitersReducer
  );

  const newArray = new Map();

  waitersTurnOver.forEach((obj) => {
    const { waiterId, total, card, cash, other } = obj;
    if (newArray.has(waiterId)) {
      const existingData = newArray.get(waiterId);
      existingData.total += total;
      existingData.card += card;
      existingData.cash += cash;
      existingData.other += other;
    } else {
      newArray.set(waiterId, {
        total,
        card,
        cash,
        other,
      });
    }
  });

  const data = Array.from(newArray, ([waiterId, values]) => ({
    waiterId,
    ...values,
    waiterName: waitersTurnOver.find((obj) => obj.waiterId === waiterId)
      .waiterName,
    date: waitersTurnOver.find((obj) => obj.waiterId === waiterId).date,
    currency: waitersTurnOver.find((obj) => obj.waiterId === waiterId).currency,
  }));
  data.sort((a, b) => a.waiterName.localeCompare(b.waiterName));

  const columns = [
    {
      title: "Име",
      dataIndex: "waiterName",
      rowKey: "waiterName",
      width: "20%",
      sorter: (a, b) => a.waiterName.localeCompare(b.waiterName),
      key: "waiterName",
      render: (waiterName) => (
        <span className="waiters-info-table-text">{waiterName}</span>
      ),
    },
    {
      title: () => {
        return (
          <div style={{ whiteSpace: "nowrap" }}>
            Оборот{" "}
            {getTotalSum(waitersTurnOver, "total")
              .toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
              .replace(",", " ")}
          </div>
        );
      },
      dataIndex: "total",
      rowKey: "total",
      width: "20%",
      sorter: (a, b) => a.total - b.total,
      align: "right",
      key: "total",

      render: (total) => (
        <span className="waiters-info-table-text">{total.toFixed(2)}</span>
      ),
    },
  ];

  if (showPaymentMethods) {
    columns.splice(1, 0, {
      title: () => {
        return (
          <div style={{ whiteSpace: "nowrap" }}>
            Други{" "}
            {getTotalSum(waitersTurnOver, "other")
              .toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
              .replace(",", " ")}
          </div>
        );
      },
      dataIndex: "other",
      rowKey: "other",
      width: "20%",
      sorter: (a, b) => a.other - b.other,
      align: "center",
      key: "other",

      render: (other) => (
        <span className="waiters-info-table-text">{other.toFixed(2)}</span>
      ),
    });
    columns.splice(1, 0, {
      title: () => {
        return (
          <div style={{ whiteSpace: "nowrap" }}>
            Карта{" "}
            {getTotalSum(waitersTurnOver, "card")
              .toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
              .replace(",", " ")}
          </div>
        );
      },
      dataIndex: "card",
      rowKey: "card",
      width: "20%",
      sorter: (a, b) => a.card - b.card,
      align: "center",
      key: "card",

      render: (card) => (
        <span className="waiters-info-table-text">{card.toFixed(2)}</span>
      ),
    });
    columns.splice(1, 0, {
      title: () => {
        return (
          <div style={{ whiteSpace: "nowrap" }}>
            Брой{" "}
            {getTotalSum(waitersTurnOver, "cash")
              .toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
              .replace(",", " ")}
          </div>
        );
      },
      dataIndex: "cash",
      rowKey: "cash",
      width: "20%",
      sorter: (a, b) => a.cash - b.cash,
      align: "center",
      key: "cash",

      render: (cash) => (
        <span className="waiters-info-table-text">{cash.toFixed(2)}</span>
      ),
    });
  }

  return (
    <>
      <div className="waiters-info-table-container">
        <Table
          loading={loading}
          rowKey="waiterId"
          showHeader
          dataSource={data}
          columns={columns}
          pagination={false}
          className="waiters-info-table"
          onRow={(record) => {
            return {
              onClick: () => {
                setSelectedRecord(
                  waitersTurnOver.filter(
                    (data) => data.waiterId === record.waiterId
                  )
                );
                setShowWaiterSalesDetails(true);
              },
            };
          }}
        />
      </div>
      {Object.keys(selectedRecord).length !== 0 && (
        <WaiterInfoModal record={selectedRecord} />
      )}
    </>
  );
};

export default WaiterInfoTable;
